
import http, { Response } from '@utils/http/http';
import * as types from './type';

// 列表接口
export const goodsListApi = (data: types.goodsListParams) =>{
  return http.post<Response<types.goodsListResponse>>('/tfshop/coupon/goods/list',data)
}


// 获取店铺信息
export const shopInfoApi = (param = {}) => {
  return http.post('/tfshop/shop/getHomePageShop',param)
}
